import { CongratulationScreen } from '@/global/components/CongratulationScreen';
import { TranslationKeys } from '@/localization';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type AudienceConfirmationProps = {
  primaryButton?: {
    text: TranslationKeys;
    icon?: ReactNode;
    onClick: VoidFunction;
  };
  secondaryButton?: {
    text: TranslationKeys;
    icon?: ReactNode;
    onClick: VoidFunction;
  };
};

export const AudienceConfirmation: FC<AudienceConfirmationProps> = ({ primaryButton, secondaryButton }) => {
  const { t } = useTranslation('ALL');

  return (
    <CongratulationScreen
      title='ALL.createdAudienceMessage'
      titleValues={{ audience: t('audience_one') }}
      subtitle='ALL.youAreReadyToActivateDestination'
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
    />
  );
};
